import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { OrderService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

declare var window: any;

class ModalPayment extends React.Component<Props> {

	state = {
		item: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await OrderService.admin.view({
			order_id: this.props.item?.id
		});
		this.setState({
			item: res.order
		});
	}

	view = (e: any, url: string) => {
		if (window.webkit && window.webkit.messageHandlers) {
			e.preventDefault();
			const message = 'open_url';
			const sendToNative = {
				message,
				url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	} 

	render() {
		const item: any = this.state.item;

		return (
			<div id="modal-view-payment">
				<p><span>Nº Orden:</span> { item?.number }</p>
				{ item?.payment?.payment_method?.name && <p><span>Método de Pago:</span> { item?.payment?.payment_method?.name }</p> }
				{ item?.payment?.bank?.name && <p><span>Banco emisor:</span> { item?.payment?.bank?.name }</p> }
				{ item?.payment?.date && <p><span>Fecha:</span> { moment(item?.payment?.date).format('DD/MM/YYYY') }</p> }
				{ item?.payment?.phone && <p><span>Teléfono:</span> { item?.payment?.phone }</p> }
				{ item?.payment?.email && <p><span>Correo emisor:</span> { item?.payment?.email }</p> }
				{ item?.payment?.reference && <p><span>Nº de Referencia:</span> { item?.payment?.reference }</p> }
				{ item?.payment?.photo && <p><span>Captura del pago:</span> <a onClick={ (e: any) => this.view(e,Constants.BASE_PUBLIC + item?.payment?.photo) } href={ Constants.BASE_STORAGE + item?.payment?.photo } target="_blank">Ver</a></p> }
				<div className="text-center">
					<Button type="button" className="btn-cancel" onClick={ () => this.props.onClose() }>
						Cerrar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalPayment;